  <mat-date-range-input [rangePicker]="picker">
    <input matStartDate placeholder="Start date" [value]="startDate"/>
    <input matEndDate placeholder="End date" />
  </mat-date-range-input>
  <mat-date-range-picker #picker [dateClass]="dateClass" (closed)="dayClicked()"> </mat-date-range-picker>